export default __webpack_public_path__ + "static/media/registered-icon.99259802.svg";